"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Localization_1 = require("../../internationalization/Localization");
var LocalNumberFormatStyle;
(function (LocalNumberFormatStyle) {
    LocalNumberFormatStyle["decimal"] = "decimal";
    LocalNumberFormatStyle["currency"] = "currency";
    LocalNumberFormatStyle["percent"] = "percent";
    //unit = 'unit',
})(LocalNumberFormatStyle = exports.LocalNumberFormatStyle || (exports.LocalNumberFormatStyle = {}));
exports.formatNumberToLocal = function (value, locale, options) {
    if (options === void 0) { options = {}; }
    var defaults = {
        style: LocalNumberFormatStyle.decimal,
        useGrouping: true,
    };
    var currencySign = options.currencySign, filteredOptions = __rest(options, ["currencySign"]);
    var merged = __assign(__assign({}, defaults), filteredOptions);
    var invalidCurrencyCode = undefined;
    var setInvalidCurrencyCode = function () {
        //let toLocaleString() format currencyCode placeholder (XXX), then replace it with invalidCurrencyCode.
        //this will avoid error and display invalid code
        invalidCurrencyCode =
            typeof merged.currency === 'string' ? merged.currency.trim() : '';
        merged.currency = 'XXX';
    };
    //custom currency rules
    if (merged.style === LocalNumberFormatStyle.currency) {
        //Upstream system may return currency code with extra character for their own organisational purposes.
        //Trim anything after 3 characters
        if (merged.currency && merged.currency.length >= 3) {
            merged.currency = merged.currency.substring(0, 3);
            var hasOnlyLetters = /^[a-zA-Z]+$/.test(merged.currency);
            if (!hasOnlyLetters)
                setInvalidCurrencyCode();
        }
        //for all other invalid currency codes
        else {
            setInvalidCurrencyCode();
        }
        //default JPY currency to be rounded to whole number
        //this can be overridden if disableDefaultJPYCurrencyRounding is true
        if (merged.currency === 'JPY' &&
            !merged.disableDefaultJPYCurrencyRounding) {
            merged.minimumFractionDigits = 0;
            merged.maximumFractionDigits = 0;
        }
    }
    var toLocaleStringSupportsOptions = typeof Intl == 'object' && Intl && typeof Intl.NumberFormat == 'function';
    var formattedValue = String(value);
    try {
        //check browser supports toLocaleString options
        if (toLocaleStringSupportsOptions) {
            if (currencySign === 'accounting' && value < 0) {
                var absValue = Math.abs(value);
                formattedValue = '(' + absValue.toLocaleString(locale, merged) + ')';
            }
            else
                formattedValue = value.toLocaleString(locale, merged);
            //replace placeholder (XXX) with invalid currency code after formatted
            if (invalidCurrencyCode !== undefined) {
                var placeHolder = invalidCurrencyCode === '' ? /\sXXX|XXX\s/ : /XXX/;
                formattedValue = formattedValue.replace(placeHolder, invalidCurrencyCode);
            }
        }
        else {
            /** We should always have browser support according to
             * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString#browser_compatibility
             * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
             * https://caniuse.com/?search=intl%3A%20numberformatbasic
             * But because of the large amount of refactoring this will cause in MI app, we provide basic backup support, just in case.
             */
            var negitive = '';
            if (value < 0) {
                if (currencySign !== 'accounting')
                    negitive = '-';
                formattedValue = String(Math.abs(value));
            }
            var curSymbol = invalidCurrencyCode
                ? invalidCurrencyCode + " "
                : merged.currency && merged.style === LocalNumberFormatStyle.currency
                    ? Localization_1.local.get("currencyIsoSymbol." + merged.currency)
                    : '';
            if (merged.maximumFractionDigits !== undefined) {
                formattedValue = Number(formattedValue).toFixed(merged.maximumFractionDigits);
            }
            formattedValue = negitive + curSymbol + formattedValue;
            if (currencySign === 'accounting') {
                formattedValue = '(' + formattedValue + ')';
            }
        }
    }
    catch (e) {
        if (options.onLocaleError)
            options.onLocaleError(e);
        else
            throw e;
    }
    return formattedValue;
};
//convenience method for currency
exports.formatCurrencyToLocal = function (value, locale, options) {
    if (options === void 0) { options = {}; }
    var defaults = {
        style: LocalNumberFormatStyle.currency,
        useGrouping: true,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };
    var merged = __assign(__assign({}, defaults), options);
    return exports.formatNumberToLocal(value, locale, merged);
};
var LocalNumberFormatComp = function (_a) {
    var 
    //required
    value = _a.value, locale = _a.locale, 
    //options
    style = _a.style, useGrouping = _a.useGrouping, currency = _a.currency, currencySign = _a.currencySign, minimumIntegerDigits = _a.minimumIntegerDigits, minimumFractionDigits = _a.minimumFractionDigits, maximumFractionDigits = _a.maximumFractionDigits, minimumSignificantDigits = _a.minimumSignificantDigits, maximumSignificantDigits = _a.maximumSignificantDigits, disableDefaultJPYCurrencyRounding = _a.disableDefaultJPYCurrencyRounding, onLocaleError = _a.onLocaleError, 
    //html props
    htmlProps = __rest(_a, ["value", "locale", "style", "useGrouping", "currency", "currencySign", "minimumIntegerDigits", "minimumFractionDigits", "maximumFractionDigits", "minimumSignificantDigits", "maximumSignificantDigits", "disableDefaultJPYCurrencyRounding", "onLocaleError"]);
    var options = {
        style: style,
        useGrouping: useGrouping,
        currency: currency,
        currencySign: currencySign,
        minimumIntegerDigits: minimumIntegerDigits,
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
        minimumSignificantDigits: minimumSignificantDigits,
        maximumSignificantDigits: maximumSignificantDigits,
        disableDefaultJPYCurrencyRounding: disableDefaultJPYCurrencyRounding,
        onLocaleError: onLocaleError,
    };
    return (React.createElement("span", __assign({}, htmlProps, { className: classnames_1.default('LocalNumberFormat', htmlProps.className) }), exports.formatNumberToLocal(value, locale, options)));
};
LocalNumberFormatComp.defaultProps = {
    style: LocalNumberFormatStyle.decimal,
    useGrouping: true,
};
exports.LocalNumberFormat = React.memo(LocalNumberFormatComp);
